import React, { createContext, useContext, useMemo, useState } from 'react';

const noop = () => {};

const ProfileNavActionContext = createContext({
  profileNavAction: null,
  setProfileNavAction: noop,
});

export function ProfileNavActionProvider({ children }) {
  const [profileNavAction, setProfileNavAction] = useState(null);
  const value = useMemo(
    () => ({ profileNavAction, setProfileNavAction }),
    [profileNavAction],
  );

  return (
    <ProfileNavActionContext.Provider value={value}>
      {children}
    </ProfileNavActionContext.Provider>
  );
}

export const useProfileNavAction = () =>
  useContext(ProfileNavActionContext);
